import React, { ChangeEvent, FocusEventHandler } from 'react';
import { Stack } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    label: string;
    name: string;
    size?: undefined | 'small' | 'medium';
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: any;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: string;
    minDate?: any;
    maxDate?: any;
    disabled?: any;
    disablePast?: boolean;
    disableFuture?: boolean;
    onChange?: (value: ChangeEvent<HTMLInputElement> | null) => void;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    idelem?: string;
};

const DatePickerField = ({
    label,
    name,
    touched,
    errors,
    minDate = undefined,
    maxDate = undefined,
    disabled,
    disablePast = false,
    disableFuture = false,
    onChange,
    required,
    size,
    value,
    onBlur,
    idelem,
}: Props) => {
    //onChange Formik
    //The variable timeVariableFormik must be equal to the variable name of the formik
    //onChange={(value) => formik.setFieldValue('dateVariableFormik', value, true)}

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <Stack component="div">
                    <DatePicker
                        label={label}
                        value={value || null}
                        disabled={disabled}
                        disablePast={disablePast}
                        minDate={minDate}
                        maxDate={maxDate}
                        disableFuture={disableFuture}
                        onChange={onChange}
                        slotProps={{
                            textField: {
                                id: idelem,
                                name: name,
                                size: size,
                                required: required,
                                error: (touched && Boolean(errors)) || false,
                                helperText: touched ? errors : '',
                                onBlur: onBlur,
                            },
                        }}
                        sx={{
                            '& label.Mui-focused': {
                                color: 'primary.main',
                            },
                            '& .MuiInput-underline:after': {
                                borderBottomColor: 'primary.main',
                            },
                            '& .MuiFilledInput-underline:after': {
                                borderBottomColor: 'primary.main',
                            },
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: 'primary.main',
                                },
                            },
                        }}
                    />
                </Stack>
            </LocalizationProvider>
        </>
    );
};

export default DatePickerField;
